<template>
  <v-dialog :persistent="options.persistent" max-width="300" v-model="dialog">
    <v-card>
      <v-system-bar height="16" color="primary"></v-system-bar>
      <!-- <v-card-title class="headline">{{ title }}</v-card-title> -->
      <v-card-title v-html="title" style="word-break: break-word;"></v-card-title>      
      <v-card-subtitle>{{ subtitle }}</v-card-subtitle>
      <v-card-text v-html="message"></v-card-text>
      <v-card-actions v-show="buttonText != ''">
        <v-spacer></v-spacer>
        <v-btn color="primary" class="primaryText--text" @click.native="close">{{ buttonText }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  //name: "Modal",
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      title: null,
      subtitle: null,
      message: null,
      options: {},
    };
  },
  watch: {},
  computed: {
    buttonText() {
      let text = this.options.buttonText;
      if (text != "" && this.options.translate) {
        text = this.$t(text);
      }
      return text;
    },
  },
  methods: {
    open(title, subtitle, message, options = null) {
      this.dialog = true;
      this.title = title;
      this.subtitle = subtitle;
      this.message = message;
      this.options = {
        buttonText: "ok",
        translate: true,
        timer: 0,
        persistent: true,
      };
      if (options != null) {
        this.options = Object.assign(this.options, options);
      }
      if (this.options.timer > 0) {
        setTimeout(() => this.close(), this.options.timer);
      }

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    close() {
      console.log("closing message dialog");

      this.resolve(true);
      this.dialog = false;
    },
  },
  created() {},
};
</script>

<style lang="css" scoped>
.modal {
  background-color: rgba(0, 0, 0, 0.7);
}
</style>
